import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { SwiperModule, SWIPER_CONFIG, SwiperConfigInterface } from 'ngx-swiper-wrapper';

import { AgGridModule } from 'ag-grid-angular';

import { HAuthGuard } from '@home/service/auth.guard';

import { SharedModule } from '@app/shared.module';

import { HomeRoutingModule } from '@home/home-routing.module';
import { HomeComponent } from '@home/home.component';

import { MainComponent } from '@home/page/main/main.component';
import { HeaderComponent } from '@home/page/main/header/header.component';
import { FooterComponent } from '@home/page/main/footer/footer.component';
import { SubHeaderComponent } from '@home/page/main/sub-header/sub-header.component';

import { MemberListComponent } from '@home/page/member-info/member-list/member-list.component';
import { MemberViewComponent } from '@home/page/member-info/member-list/member-view/member-view.component';

import { RecruitComponent } from '@home/page/information/recruit/recruit.component';
import { RecruitView1Component } from '@home/page/information/recruit/recruit-view1/recruit-view1.component';
import { RecruitView2Component } from '@home/page/information/recruit/recruit-view2/recruit-view2.component';
import { RecruitAdd1Component } from '@home/page/information/recruit/recruit-add1/recruit-add1.component';
import { RecruitAdd2Component } from '@home/page/information/recruit/recruit-add2/recruit-add2.component';
import { InformationBiddingComponent } from '@home/page/information/information-bidding/information-bidding.component';

import { MagazineComponent } from '@home/page/customer-center/magazine/magazine.component';
import { MagazineContentsComponent } from '@home/page/customer-center/magazine/magazine-contents/magazine-contents.component';
import { MagazineSubscriptionComponent } from '@home/page/customer-center/magazine/magazine-subscription/magazine-subscription.component';

import { BoardComponent } from '@home/page/board/board.component';
import { BoardListComponent } from '@home/page/board/board-list/board-list.component';
import { BoardViewComponent } from '@home/page/board/board-view/board-view.component';
import { BoardWriteComponent } from '@home/page/board/board-write/board-write.component';
import { BoardReplyComponent } from '@home/page/board/board-reply/board-reply.component';

import { StatisticsComponent } from '@home/page/statistics/statistics.component';
import { StatisticsPg1Component } from '@home/page/statistics/statistics-pg1/statistics-pg1.component';
import { StatisticsPg2Component } from '@home/page/statistics/statistics-pg2/statistics-pg2.component';
import { StatisticsPg3Component } from '@home/page/statistics/statistics-pg3/statistics-pg3.component';
import { StatisticsPg4Component } from '@home/page/statistics/statistics-pg4/statistics-pg4.component';

import { LoginComponent } from '@home/page/member/login/login.component';
import { FindIdComponent } from '@home/page/member/find-id/find-id.component';
import { FindPwComponent } from '@home/page/member/find-pw/find-pw.component';
import { MemberJoinComponent } from '@home/page/member/member-join/member-join/member-join.component';
import { MemberJoinCompleteComponent } from '@home/page/member/member-join/member-join-complete/member-join-complete.component';
import { CompanySearchComponent } from '@home/page/member/member-join/company-search/company-search.component';
import { FindIdResultComponent } from '@home/page/member/find-id/find-id-result/find-id-result.component';
import { FindPwResultComponent } from '@home/page/member/find-pw/find-pw-result/find-pw-result.component';
import { MemberEdit1Component } from '@home/page/member/mypage/member-edit/member-edit1/member-edit1.component';
import { MemberWithdrawalComponent } from '@home/page/member/mypage/member-withdrawal/member-withdrawal.component';

import { PaidMemberStep1Component } from '@home/page/member/mypage/paid-member/paid-member-step1/paid-member-step1.component';
import { PaidMemberStep2Component } from '@home/page/member/mypage/paid-member/paid-member-step2/paid-member-step2.component';
import { PaidMemberBankComponent } from '@home/page/member/mypage/paid-member/paid-member-step1/paid-member-bank/paid-member-bank.component';

import { AgGridImageComponent } from '@components/ag-grid-image/ag-grid-image.component';
import { AgGridHtmlComponent } from '@components/ag-grid-html/ag-grid-html.component';
import { AgGridSaveComponent } from '@components/ag-grid-save/ag-grid-save.component';
import { AgGridExcelComponent } from '@components/ag-grid-excel/ag-grid-excel.component';
import { AgGridHeaderCheckboxComponent } from '@components/ag-grid-header-checkbox/ag-grid-header-checkbox.component';

import { ModalMonthComponent } from '@components/modal-month/modal-month.component';
import { ContentsComponent } from '@home/page/contents/contents.component';
import { MypagePaymentComponent } from '@home/page/member/mypage/mypage-payment/mypage-payment.component';
import { MemberDormantComponent } from '@home/page/member/member-dormant/member-dormant.component';

import { UnsubscribeComponent } from './page/newsletter/unsubscribe/unsubscribe.component';
import { HomeAhriComponent } from './page/home-ahri/home-ahri.component';

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

@NgModule({
  declarations: [
    HomeComponent,

    // DaumAddressComponent,
    MainComponent,
    HeaderComponent,
    FooterComponent,
    SubHeaderComponent,

    MemberListComponent,
    MemberViewComponent,

    RecruitComponent,
    RecruitView1Component,
    RecruitView2Component,
    RecruitAdd1Component,
    RecruitAdd2Component,
    InformationBiddingComponent,

    MagazineComponent,
    MagazineContentsComponent,
    MagazineSubscriptionComponent,

    BoardComponent,
    BoardListComponent,
    BoardViewComponent,
    BoardWriteComponent,
    BoardReplyComponent,

    StatisticsComponent,
    StatisticsPg1Component,
    StatisticsPg2Component,
    StatisticsPg3Component,
    StatisticsPg4Component,

    LoginComponent,
    FindIdComponent,
    FindPwComponent,
    MemberJoinComponent,
    MemberJoinCompleteComponent,
    CompanySearchComponent,
    FindIdResultComponent,
    FindPwResultComponent,
    MemberEdit1Component,
    MemberWithdrawalComponent,
    PaidMemberStep1Component,
    PaidMemberStep2Component,
    PaidMemberBankComponent,

    ContentsComponent,

    MypagePaymentComponent,

    MemberDormantComponent,

    UnsubscribeComponent,

    HomeAhriComponent,
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    SwiperModule,
    SharedModule,
    AgGridModule.withComponents([
      AgGridImageComponent,
      AgGridHtmlComponent,
      AgGridHeaderCheckboxComponent
    ])    
  ],
  providers: [
    HAuthGuard,
    NgbActiveModal,
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ],
  entryComponents: [
    CompanySearchComponent,
    MemberViewComponent,
    MagazineContentsComponent,
    PaidMemberBankComponent,
    ModalMonthComponent

  ]
})
export class HomeModule { }
